import dayjs from "dayjs";

import { createColumnHelper } from "@/shared/foundation/primitives/Table";
import { nanoSecToDate } from "@/shared/time";

import { EventRecord } from "./EventRecord";
import styles from "./EventsTableColumns.module.css";

const columnHelper = createColumnHelper<EventRecord>();

export function formatNanoTimestamp(value: bigint | undefined | null): string {
  if (value === undefined || value === null) {
    return "";
  }
  try {
    return dayjs(nanoSecToDate(BigInt(value))).format("MMM D, YYYY h:mm A");
  } catch {
    return "";
  }
}

export const eventsTableColumns = [
  columnHelper.accessor("event_id", {
    headerName: "ID",
    width: 180,
    cellClass: styles.monoCell,
  }),
  columnHelper.accessor("name", {
    headerName: "Name",
    flex: 1,
    sortable: true,
  }),
  columnHelper.accessor("description", {
    headerName: "Description",
    flex: 3,
  }),
  columnHelper.accessor("start_time", {
    headerName: "Start",
    width: 200,
    sortable: true,
    cellClass: styles.monoCell,
    valueFormatter: (p) => formatNanoTimestamp(p.value),
  }),
  columnHelper.accessor("end_time", {
    headerName: "End",
    width: 200,
    sortable: true,
    cellClass: styles.monoCell,
    valueFormatter: (p) => formatNanoTimestamp(p.value),
  }),
];
